import React from 'react';
import ExpansionPanelGroup from 'emerald-ui/lib/ExpansionPanelGroup';
import Avatar from 'emerald-ui/lib/Avatar';
import IconButton from 'emerald-ui/lib/IconButton';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: ExpansionPanelGroup, componentName: 'ExpansionPanelGroup' }], 'ExpansionPanelGroup'),
  description: (
    <span>
      Controls the expansion state of several ExpansionPanel components. To add a Panel inside use{' '}
      <span className="code">ExpansionPanelGroup.Panel</span>
      (The props are the same as the ExpansionPanel’s props). For the summary content use
      <span className="code">ExpansionPanelGroup.Panel.Summary</span>, for the alternative summary content use
      <span className="code">ExpansionPanelGroup.Panel.AlternativeSummary</span>
      and for the expandable content use
      <span className="code">ExpansionPanelGroup.Panel.Content</span>.
    </span>
  ),
  codeSamples: [
    {
      title: 'Default',
      scope: { Avatar, ExpansionPanelGroup, IconButton },
      code: `<ExpansionPanelGroup id="g1">
  <ExpansionPanelGroup.Panel>
    <ExpansionPanelGroup.Panel.Summary>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Avatar size="lg" title="JS" />
        <div
          style={{
            marginLeft: '35px',
            flexGrow: 1
          }}
        >
          <h3 style={{ marginTop: 0, marginBottom: '3px' }}>
            <strong>Brunch this weekend?</strong>
          </h3>
          <p style={{ margin: 0 }}>
            Ali Connors
            <span className="text-muted">
              I will be in your neighbourhood doing errands this weekend
            </span>
          </p>
        </div>
      </div>
    </ExpansionPanelGroup.Panel.Summary>
    <ExpansionPanelGroup.Panel.AlternativeSummary>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start'
        }}
      >
        <h1 style={{ margin: 0 }}>Brunch this weekend?</h1>
        <div
          className="btn-toolbar"
          style={{ marginTop: '5px', marginRight: '20px' }}
        >
          <IconButton
            ariaLabel="Settings"
            onClick={event => {
              event.stopPropagation();
              event.preventDefault();
            }}
            icon="settings"
          />
          <IconButton
            ariaLabel="Delete"
            onClick={event => {
              event.stopPropagation();
              event.preventDefault();
            }}
            icon="delete"
          />
          <IconButton
            ariaLabel="Done"
            onClick={event => {
              event.stopPropagation();
              event.preventDefault();
            }}
            icon="done"
          />
          <IconButton
            ariaLabel="More options"
            onClick={event => {
              event.stopPropagation();
              event.preventDefault();
            }}
            icon="more_vert"
          />
        </div>
      </div>
    </ExpansionPanelGroup.Panel.AlternativeSummary>
    <ExpansionPanelGroup.Panel.Content>
      <Avatar size="lg" title="JS" style={{ marginTop: '20px' }} />
      <h2>This is the panel content</h2>
    </ExpansionPanelGroup.Panel.Content>
  </ExpansionPanelGroup.Panel>
  <ExpansionPanelGroup.Panel>
    <ExpansionPanelGroup.Panel.Summary>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Avatar size="lg" title="AB" />
        <div
          style={{
            marginLeft: '35px',
            flexGrow: 1
          }}
        >
          <h3 style={{ marginTop: 0, marginBottom: '3px' }}>
            <strong>Summer BBQ</strong>
          </h3>
          <p style={{ margin: 0 }}>
            To Alex, Scott, Jennifer
            <span className="text-muted">
              Wish I could come, but I am out of town this weekend.
            </span>
          </p>
        </div>
      </div>
    </ExpansionPanelGroup.Panel.Summary>
    <ExpansionPanelGroup.Panel.AlternativeSummary>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start'
        }}
      >
        <h1 style={{ margin: 0 }}>Summer BBQ</h1>
        <div
          className="btn-toolbar"
          style={{ marginTop: '5px', marginRight: '20px' }}
        >
          <IconButton
            ariaLabel="Settings"
            onClick={event => {
              event.stopPropagation();
              event.preventDefault();
            }}
            icon="settings"
          />
          <IconButton
            ariaLabel="Delete"
            onClick={event => {
              event.stopPropagation();
              event.preventDefault();
            }}
            icon="delete"
          />
          <IconButton
            ariaLabel="Done"
            onClick={event => {
              event.stopPropagation();
              event.preventDefault();
            }}
            icon="done"
          />
          <IconButton
            ariaLabel="More options"
            onClick={event => {
              event.stopPropagation();
              event.preventDefault();
            }}
            icon="more_vert"
          />
        </div>
      </div>
    </ExpansionPanelGroup.Panel.AlternativeSummary>
    <ExpansionPanelGroup.Panel.Content>
      <Avatar size="lg" title="AB" style={{ marginTop: '20px' }} />
      <h2>This is the panel content</h2>
    </ExpansionPanelGroup.Panel.Content>
  </ExpansionPanelGroup.Panel>
  <ExpansionPanelGroup.Panel>
    <ExpansionPanelGroup.Panel.Summary>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Avatar size="lg" title="YZ" />
        <div
          style={{
            marginLeft: '35px',
            flexGrow: 1
          }}
        >
          <h3 style={{ marginTop: 0, marginBottom: '3px' }}>
            <strong>Oui Oui</strong>
          </h3>
          <p style={{ margin: 0 }}>
            Ali Connors
            <span className="text-muted">
              I will be in your neighbourhood
            </span>
          </p>
        </div>
      </div>
    </ExpansionPanelGroup.Panel.Summary>
    <ExpansionPanelGroup.Panel.AlternativeSummary>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start'
        }}
      >
        <h1 style={{ margin: 0 }}>Oui Oui</h1>
        <div
          className="btn-toolbar"
          style={{ marginTop: '5px', marginRight: '20px' }}
        >
          <IconButton
            ariaLabel="Settings"
            onClick={event => {
              event.stopPropagation();
              event.preventDefault();
            }}
            icon="settings"
          />
          <IconButton
            ariaLabel="Delete"
            onClick={event => {
              event.stopPropagation();
              event.preventDefault();
            }}
            icon="delete"
          />
          <IconButton
            ariaLabel="Done"
            onClick={event => {
              event.stopPropagation();
              event.preventDefault();
            }}
            icon="done"
          />
          <IconButton
            ariaLabel="More options"
            onClick={event => {
              event.stopPropagation();
              event.preventDefault();
            }}
            icon="more_vert"
          />
        </div>
      </div>
    </ExpansionPanelGroup.Panel.AlternativeSummary>
    <ExpansionPanelGroup.Panel.Content>
      <Avatar size="lg" title="YZ" style={{ marginTop: '20px' }} />
      <h2>This is the panel content</h2>
    </ExpansionPanelGroup.Panel.Content>
  </ExpansionPanelGroup.Panel>
</ExpansionPanelGroup>`,
    },
  ],
};
